import ThemeSwitcher from '../../application/theme/ThemeSwitcher.tsx';

const ThemePage = () => {
    return (
        <div>
            <h1 className="text-2xl text-center mb-10">Theme Page</h1>
            <ThemeSwitcher />
        </div>
    );
};

export default ThemePage;
